/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useTranslation } from "react-i18next";
import { CustomButton } from "../../components";
import "./styles.scss";
import { GreenTickCircle } from "../../assets/svgs";
import { useLocation } from "react-router-dom";

const BottomContentModal = ({ visible, onClickFilter, onClickBackdrop }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];

  const handleOnClickFilter = () => {
    onClickFilter();
  };

  const steps = [
    {
      title: "select_your_bank",
      description: "select_your_bank_description",
    },
    {
      title: "review_permission",
      description: "review_permission_description",
    },
    {
      title: "select_your_bank_account",
      description: "select_your_bank_account_description",
    },
  ];

  return (
    <div>
      <div
        className={`how-it-work-modal-container ${visible ? "show" : "hide"}`}
        onClick={onClickBackdrop}
      >
        <div
          className="how-it-works-card-modal-content"
          onClick={(event) => event.stopPropagation()}
        >
          <div className="card-header" />
          <h2 className="title">{t(`${routeName}.how_it_work`)}</h2>
          <p className="description">
            {t(`${routeName}.securely_connect_your_bank`)}
          </p>

          <ul className="steps">
            {steps.map((step, index) => (
              <li key={index}>
                <div className="d-flex align-items-center">
                  <img src={GreenTickCircle} alt="check" />
                  <strong>{t(`${routeName}.${step.title}`)}</strong>
                </div>
                <p>{t(`${routeName}.${step.description}`)}</p>
              </li>
            ))}
          </ul>

          <CustomButton
            text={t(`${routeName}.got_it`)}
            onClick={handleOnClickFilter}
          />
        </div>
      </div>
    </div>
  );
};

export default BottomContentModal;
